import { render, staticRenderFns } from "./form-title.vue?vue&type=template&id=4be855b7"
import script from "./form-title.vue?vue&type=script&lang=js"
export * from "./form-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports